/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest = {
  accountAddress: string;
};

/** @internal */
export const GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    account_address: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "account_address": "accountAddress",
    });
  });

/** @internal */
export type GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$Outbound =
  {
    account_address: string;
  };

/** @internal */
export const GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest
  > = z.object({
    accountAddress: z.string(),
  }).transform((v) => {
    return remap$(v, {
      accountAddress: "account_address",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$ {
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$Outbound;
}

export function getApiV3ImagesAccountsAccountAddressTransactionFlowPngRequestToJSON(
  getApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest:
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$outboundSchema
      .parse(getApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest),
  );
}

export function getApiV3ImagesAccountsAccountAddressTransactionFlowPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest' from JSON`,
  );
}
